import { Injectable } from '@angular/core';
import { User } from '@spartacus/core';
import { UserSignUp } from '@spartacus/user/profile/root';
import { Observable } from 'rxjs';
import { CustomDocumentIdentifierValidatorAdapter } from './custom-document-identifier-validator.adapters';

@Injectable({
  providedIn: 'root',
})
export class CustomDocumentIdentifierValidatorConnector {
  constructor(protected adapter: CustomDocumentIdentifierValidatorAdapter) {
  }

  public documentIdentifierValidator(user: UserSignUp): Observable<User> {
    return this.adapter.documentIdentifierValidator(user);
  }
}
